import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { isUndefined } from 'util';
import { VkService } from '../vk.service';
import { NotifierWrapService } from '../../../services/notifier-wrap.service';
import { VkLongPullService } from '../vk.longpull.service';
import { AllService } from '../../../services/all.service';
import { Router } from '@angular/router';
import {throttleTime} from "rxjs";

@Component({
  selector: 'app-sign-vk',
  templateUrl: './sign-vk.component.html',
  styleUrls: ['./sign-vk.component.scss']
})
export class SignVkComponent implements OnInit {
  Form: UntypedFormGroup;
  _isLoading = false;
  constructor(
    private cd: ChangeDetectorRef,
    private router: Router,
    public allService: AllService,
    public vkLongPullService: VkLongPullService,
    public notifierWrapService: NotifierWrapService,
    private vkService: VkService
  ) {}

  ngOnInit(): void {
    this.Form = new UntypedFormGroup({
      username: new UntypedFormControl('cosangeles@mail.ru', Validators.required),
      password: new UntypedFormControl('', [Validators.required, Validators.minLength(1)])
    });
  }
  onSubmit() {
    this.isLoading = true;
    const controls = this.Form.controls;
    const values = this.Form.value;

    // Проверяем форму на валидность */
    if (this.Form.invalid) {
      // Если форма не валидна, помечаем все контролы как touched **/
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    }
    this.vkService.login(values.username, values.password).subscribe(
      (result: any) => {
        if (isUndefined(result.error_msg)) {
          this.vkService.setToken(result.access_token);
          this.vkService.loadProfile();
          this.vkLongPullService.initPullServer$.next();
          this.goPage();
        } else {
          this.notifierWrapService.notify('error', result.error_msg);
        }
        this.isLoading = false;
      },
      (error) => {
        this.vkService.errorHandling(error);
        this.isLoading = false;
      }
    );
  }
  goPage(): void {
    //this.router.navigate([`/${this.vkService.type}/`]);
  }
  get isLoading() {
    return this._isLoading;
  }
  set isLoading(val) {
    this._isLoading = val;
    this.cd.detectChanges();
  }
}
